import React, { useCallback } from "react";
import { useState, useEffect } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import ClickBack from "../../../components/buttons/ClickBack";
import { useHistory } from "react-router-dom";
import {
  CreateFournisseurCommande,
  FetchAllLivreur,
  FetchListFournisseur,
  FetchListParticuliers,
  FetchListEntreprises,
  fetchAdressesRamassageClient,
} from "./DataService";
import { ErrorMessage, Field, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import ModalValidation from "../../../components/modal/ModalValidation";
import ConfirmationPaiementCarte from "../../../components/modal/ConfirmationPaiementCarte";
import { toast } from "react-toastify";

import { REACT_APP_GOOGLE_MAPS_API_KEY } from "../../../utils/ApiConfig.js";
import PlacesAutocompleteComponent from "../Component/PlacesAutocompleteComponent.jsx";

function AddCommandeFournisseur() {
  const [isGMapsLoaded, setIsGMapsLoaded] = useState(false);
  // Aucune valeur par defaut : les supplements viennent de la grille du CLIENT
  // choisi, et 9,90 ecrit en dur ici sous-facturait un client hors compte de
  // cinq euros sur une planifiee, en silence. Vide, rien n'est prerempli et
  // l'ops le voit.
  const [pricingSupplements, setPricingSupplements] = useState(null);
  // Les adresses d'enlevement du client, avec leurs coordonnees. En choisir une
  // garantit la latitude et la longitude sans geocodage : c'est le chemin le
  // plus sur des trois.
  const [adressesClient, setAdressesClient] = useState(null);
  // Manutention a la creation. Etat separe de Formik, comme a l'edition : ce
  // bloc a ses propres regles et son propre mode.
  const [manutentionReponses, setManutentionReponses] = useState({
    distance: "",
    obstacles: "",
    etage: "",
    ascenseur: "",
    poids_colis: "",
  });
  const [manutentionMontant, setManutentionMontant] = useState("");
  // Le mode « montant negocie » est actif des qu'un montant est saisi, et il
  // desactive le bareme — reciproquement plus bas. Le serveur refuse les deux
  // modes a la fois ; on l'empeche des l'interface plutot que d'attendre un 422.
  const montantManutentionSaisi = String(manutentionMontant).trim() !== "";
  //Fonction pour la validation du formulaire d'ajout
  const validationSchema = Yup.object().shape({
    client_type: Yup.string().required("Type de client est requis"),
    fournisseur: Yup.string().required("Client/Utilisateur est requis"),
    numBonLivraison: Yup.string().required(
      "Numéro Bon de Livraison est requis"
    ),
    livraisonHT: Yup.number()
      .typeError("Le tarif doit être un nombre")
      .required("Tarif de la livraison est requis")
      .min(0, "Le tarif ne peut pas être négatif"),
    commission: Yup.string().nullable(),
    TVA: Yup.string().required("TVA est requis"),
    TTC: Yup.string().required("TTC est requis"),
    livreur: Yup.string().required("Livreur est requis"),
    telephone_client: Yup.string()
      .required("N° de Telephone Client est requis")
      .matches(
        /^0\d{9}$/,
        "Le numéro doit commencer par 0 et contenir 10 chiffres"
      ),
    NomClient: Yup.string().required("Nom Client est requis"),
    PrenomClient: Yup.string().required("Prènom Client est requis"),
    telFournisseurVal: Yup.string().nullable(),
    RaisonSocialClient: Yup.string().nullable(),
    // Meme plafond que la validation serveur et que la colonne.
    reference_client: Yup.string().nullable().max(50, "50 caractères maximum."),
    date_livraisson: Yup.string().required("Date Livraisson est requis"),
    statut_paiement: Yup.string().required("Statut Paiement est requis"),
    statut_commande: Yup.string().required("Statut Commande est requis"),
    MontantCommande: Yup.number()
      .required("Le montant de la Commande est requis")
      .max(9999.99, "Le montant ne peut pas dépasser 9999.99€"),
    selectedFournisseurEmail: Yup.string()
      .email("Email invalide")
      .nullable(),
    Commentaire: Yup.string()
      .max(500, "Le commentaire ne peut pas dépasser 500 caractères")
      .nullable(),
       // Vérification des adresses
       pickupAdr: Yup.string()
       .required("Adresse requise")
       .test(
         "is-selected-from-suggestions",
         "Vous devez sélectionner une adresse depuis les suggestions !",
         (value, context) => {
           const { altitude_Fournisseur, longitude_Fournisseur } = context.parent;
           return !!(altitude_Fournisseur && longitude_Fournisseur);
         }
      ),

     address: Yup.string()
       .required("Adresse requise")
       .test(
         "is-selected-from-suggestions",
         "Vous devez sélectionner une adresse depuis les suggestions !",
         (value, context) => {
           const { altitude_Livreur, longitude_Livreur } = context.parent;
           return !!(altitude_Livreur && longitude_Livreur);
         }
       ),
    file: Yup.mixed()
      .required("Un fichier PDF est requis")
      .test(
        "fileSize",
        "La taille du fichier ne doit pas dépasser 5 Mo",
         (value) => value ? value.size <= 5 * 1024 * 1024 : false
      )
      .test("fileType",
        "Seuls les fichiers PDF sont autorisés",
         (value) =>  value ? value.type === "application/pdf" : false
      ),
  });
  const [showOkModal, setShowOkModal] = useState(false);
  const [selectedFournisseurEmail, setSelectedFournisseurEmail] = useState("");
  const [tarifLiv, setTarifLiv] = useState("");
  const [comissionVal, setComissionVal] = useState("");
  const [listFournisseurs, setListFournisseur] = useState([]);
  // Confirmation avant de creer une commande deja declaree payee par carte :
  // ce chemin ne genere aucune facture, comme l'edition. Sans condition de
  // transition ici, il n'y a pas d'etat anterieur.
  const [showPaiementCarteModal, setShowPaiementCarteModal] = useState(false);
  const [valeursEnAttente, setValeursEnAttente] = useState(null);

  /**
   * Restreint aux clients HORS COMPTE : pour un client en compte, la
   * facturation intervient en fin de mois et le statut n'engage rien
   * d'irreversible. En cas de doute sur le client, on demande.
   */
  const confirmationPaiementRequise = (values) => {
    if (String(values.statut_paiement) !== "3") return false;

    const client = listFournisseurs.find(
      (f) => String(f.id) === String(values?.fournisseur ?? "")
    );

    if (!client) return true;

    return ![true, 1, "1"].includes(client.paiement_en_compte);
  };
  const [listLivreur, setListLivreur] = useState([]);
  const [telFournisseurVal, setTelFournisseurVal] = useState("");
  const history = useHistory();
  const [file, setFile] = useState(null);
  const currentDate = new Date().toISOString().slice(0, 16);

  const handleChangeFournisseur = (e, setFieldValue) => {
    const selectedFournisseurId = e.target.value;
    const selectedFournisseur = listFournisseurs.find(
      (fournisseur) => fournisseur.id == selectedFournisseurId
    );

    if (selectedFournisseur) {
      console.log("✅ Profil complet du fournisseur sélectionné :", selectedFournisseur.user_profil);

      setSelectedFournisseurEmail(selectedFournisseur?.email);
      setFieldValue("selectedFournisseurEmail", selectedFournisseur?.email);

      const montant = selectedFournisseur?.user_profil?.montantLivraison;
      setTarifLiv(montant);
      setFieldValue("livraisonHT", montant);
      setFieldValue("tarif_base", montant);

      setComissionVal(selectedFournisseur?.user_profil?.commission);
      setFieldValue("commission", selectedFournisseur?.user_profil?.commission);

      setTelFournisseurVal(
        selectedFournisseur?.user_profil?.TelFournisseur || ""
      );
      setFieldValue(
        "telFournisseurVal",
        selectedFournisseur?.user_profil?.TelFournisseur
      );

      // Les adresses d'enlevement de CE client, et les supplements de SA grille.
      // Un seul appel pour les deux : c'est le meme service que le formulaire
      // client interroge, donc l'ops voit exactement ce que le client verrait.
      setAdressesClient(null);
      setPricingSupplements(null);
      fetchAdressesRamassageClient(selectedFournisseurId).then((data) => {
        if (!data) return;
        setAdressesClient(data);
        if (data.supplements_livraison) {
          setPricingSupplements({
            Flex: Number(data.supplements_livraison.flex),
            "Planifiée": Number(data.supplements_livraison.planifiee),
            Urgent: Number(data.supplements_livraison.urgent),
          });
        }
      });
    }
  };

  /**
   * Remplit l'adresse d'enlevement et ses coordonnees d'un seul geste.
   *
   * Les coordonnees viennent de la base, pas d'un geocodage : c'est ce qui rend
   * ce chemin plus fiable que la saisie, ou meme que les suggestions Google.
   */
  const choisirAdresseRamassage = (adresse, setFieldValue, setFieldError) => {
    // Piege de nommage, historique et partout dans ce depot : le champ
    // `altitude_Fournisseur` porte une LATITUDE, pas une altitude. La colonne
    // `altitudeFournisseur` en base aussi. Ne pas « corriger » cette affectation.
    setFieldValue("pickupAdr", adresse.adresse);
    setFieldValue("altitude_Fournisseur", adresse.latitude);
    setFieldValue("longitude_Fournisseur", adresse.longitude);
    if (setFieldError) setFieldError("pickupAdr", "");
  };


  const HandleSave = async (values) => {
    console.log("values",values)
    const formData = new FormData();
    formData.append("client_type", values.client_type);
    // id_fournisseur contient l'ID de l'utilisateur (tous types: fournisseur, particulier, entreprise)
    formData.append("id_fournisseur", values.fournisseur);

    // Email pour tous les types de clients
    selectedFournisseurEmail && formData.append("emailFournisseur", selectedFournisseurEmail);

    // Téléphone fournisseur uniquement si type = fournisseur
    if (values.client_type === 'fournisseur') {
      telFournisseurVal && formData.append("TelFournisseur", telFournisseurVal);
    }
    formData.append("NomClient", values.NomClient);
    formData.append("PrenomClient", values.PrenomClient);
    formData.append("RaisonSocialClient", values.RaisonSocialClient);
    formData.append("reference_client", values.reference_client ?? "");

    // Manutention : un seul des deux modes part, jamais les deux — le serveur
    // refuse la combinaison, et c'est lui qui chiffre. Rien n'est envoye quand
    // l'ops n'a rien renseigne : le portage reste optionnel.
    if (montantManutentionSaisi) {
      formData.append("manutention_total_ht", manutentionMontant);
    } else if (manutentionReponses.distance !== "") {
      Object.entries(manutentionReponses).forEach(([cle, valeur]) => {
        if (valeur !== "") formData.append(`manutention_${cle}`, valeur);
      });
    }
    formData.append("AdressePickUp", values.pickupAdr);
    formData.append("altitudeFournisseur", values.altitude_Fournisseur);
    formData.append("longitudeFournisseur", values.longitude_Fournisseur);
    formData.append("AdresseLivraison", values.address);
    formData.append("altitudeLivreur", values.altitude_Livreur);
    formData.append("longitudeLivreur", values.longitude_Livreur);
    formData.append("id_livreur", values.livreur);
    formData.append("Commentaire", values.Commentaire);
    formData.append("DateCommande", currentDate);
    formData.append("DateLivraison", values.date_livraisson);
    formData.append("TelClient", values.telephone_client);
    formData.append("StatuPaiement", values.statut_paiement);
    formData.append("StatuCommande", values.statut_commande);
    formData.append("NBonLivraison", values.numBonLivraison);
    formData.append("Bordereau", file);
    formData.append("MontantCommande", parseFloat(values.MontantCommande).toFixed(2));
    formData.append("livraisonHT", values.livraisonHT || 0);
    formData.append("commission", values.commission ?? 0);
    formData.append("TVA", values.TVA);
    formData.append("TTC", values.TTC);
    // ajouter la liste de neauveuax champs 
    formData.append("poids", values.poids);
    formData.append("poids_label", values.poids_label);
    formData.append("poids_supplement", values.poids_supplement);
    formData.append("temps_estime", values.temps_estime);
    formData.append("temps_supplement", values.temps_supplement);
    formData.append("tarif_base", values.tarif_base);
    formData.append("tarif_ht", values.tarif_ht);
    formData.append("tarif_ttc", values.tarif_ttc);
    formData.append("type_livraison", values.type_livraison);
    formData.append("livraison_supplement", values.livraison_supplement);
    try {
      const response = await CreateFournisseurCommande(formData);
      setShowOkModal(true);
      setTimeout(() => {
        history.push("/livraison");
      }, 1001);
    } catch (error) {
      const status = error.response?.status;
      const data   = error.response?.data;

      if (status === 403) {
        toast.error("Accès refusé : vous n'avez pas les droits pour créer une commande.");
      } else if (status === 400 || status === 422) {
        const errors = data?.errors;
        if (errors) {
          const messages = Object.values(errors).flat().join(' — ');
          toast.error(`Validation : ${messages}`);
        } else {
          toast.error(data?.message || "Données invalides, vérifiez le formulaire.");
        }
      } else {
        toast.error("Une erreur est survenue lors de la création de la commande.");
        console.error("Erreur création commande fournisseur :", error);
      }
    }
  };

  const searchOptions = {
    componentRestrictions: { country: ["fr", "mc"] },
    types: ["geocode", "establishment"],
  };

  //Cette fonction pour afficher liste des utilisateurs selon le type
  const fetchUsersByType = async (clientType) => {
    try {
      let response;
      switch (clientType) {
        case 'fournisseur':
          response = await FetchListFournisseur();
          break;
        case 'particulier':
          response = await FetchListParticuliers();
          break;
        case 'entreprise':
          response = await FetchListEntreprises();
          break;
        default:
          response = await FetchListFournisseur();
      }
      setListFournisseur(response?.data);
    } catch (error) {
      console.error("Error lors de affiche liste utilisateurs:", error);
      // En cas d'erreur, essayer de charger tous les fournisseurs par défaut
      try {
        const response = await FetchListFournisseur();
        setListFournisseur(response?.data);
      } catch (fallbackError) {
        console.error("Error lors du chargement par défaut:", fallbackError);
      }
    }
  };
  //Cette fonction pour afficher liste des livreurs
  const fetchLivreurData = async () => {
    try {
      const response = await FetchAllLivreur();
      setListLivreur(response.data);
    } catch (error) {
      console.error("Error lors de affiche liste livreur:", error);
    }
  };
  //Cette fonction pour fermer le Pop Up
  const handleOkModalClose = () => {
    setShowOkModal(false);
  };
  useEffect(() => {
    if (!window.google) {
      const gmapScriptEl = document.createElement("script");
      gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=${REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;
      gmapScriptEl.async = true;
      gmapScriptEl.defer = true;
      gmapScriptEl.onload = () => setIsGMapsLoaded(true);
      document.body.appendChild(gmapScriptEl);
    } else {
      setIsGMapsLoaded(true);
    }
  }, []);
  useEffect(() => {
    // Charger les fournisseurs par défaut
    fetchUsersByType('fournisseur');
    fetchLivreurData();
  }, []);




  return (
    <Container>
      <div>
        <p className="h6">Accueil / Livraisons / Ajouter</p>
        <Row className="pt-4 pb-2">
          <Col style={{ display: "flex", alignItems: "center" }}>
            <ClickBack editPage={true} />
            <h1 className="p-1">Ajouter une Livraison</h1>
          </Col>
        </Row>
        <Formik
          initialValues={{
            client_type: "fournisseur",
            selectedFournisseurEmail: "",
            fournisseur: "",
            telFournisseurVal: "",
            NomClient: "",
            PrenomClient: "",
            pickupAdr: "",
            altitude_Fournisseur: "",
            longitude_Fournisseur: "",
            address: "",
            altitude_Livreur: "",
            longitude_Livreur: "",
            livreur: "",
            date_livraisson: "",
            telephone_client: "",
            statut_paiement: "",
            statut_commande: 3,
            file: "",
            numBonLivraison: "",
            MontantCommande: "",
            livraisonHT: 0,
            commission: "",
            TVA: 20,
            TTC: "",
            RaisonSocialClient: "",
            reference_client: "",
            Commentaire: "",
            // ajouter les neauveaux champs 
            poids: "",
            poids_label: "",
            poids_supplement: "",
            temps_estime: "",
            temps_supplement: "",
            tarif_base: "",
            tarif_ht: "",
            tarif_ttc: "",
            type_livraison: "",
            livraison_supplement: "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, { setSubmitting }) => {
            // Commande creee directement « payee par carte » sur un client hors
            // compte : on demande une confirmation explicite avant d'enregistrer.
            if (confirmationPaiementRequise(values)) {
              setValeursEnAttente(values);
              setShowPaiementCarteModal(true);
              setSubmitting(false);
              return;
            }

            await HandleSave(values);
            setSubmitting(false);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            setFieldError,
            validateField,
            setFieldTouched,
            isValid,
            dirty,
          }) => (
            <Form onSubmit={handleSubmit}>
              <AutoUpdateLivraisonHT pricingSupplements={pricingSupplements} />
              <Card className="mb-3">
                <Card.Body>
                  <Card.Title className="pb-3">
                    Détails de la commande
                  </Card.Title>
                  <Row>
                    <Col>
                      <Form.Group
                        className="mb-3"
                        controlId="clientType"
                      >
                        <Form.Label>Type de client *</Form.Label>
                        <Form.Select
                          className="form-control"
                          value={values.client_type}
                          name="client_type"
                          onChange={(e) => {
                            handleChange(e);
                            const newType = e.target.value;
                            // Reset fields when changing type
                            setFieldValue('fournisseur', '');
                            setFieldValue('selectedFournisseurEmail', '');
                            setSelectedFournisseurEmail('');
                            if (newType !== 'fournisseur') {
                              setFieldValue('telFournisseurVal', '');
                              setTelFournisseurVal('');
                            }
                            // Charger la nouvelle liste d'utilisateurs
                            fetchUsersByType(newType);
                          }}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.client_type && !!errors.client_type
                          }
                        >
                          <option value="fournisseur">🏢 Fournisseur</option>
                          <option value="particulier">👤 Particulier</option>
                          <option value="entreprise">💼 Entreprise (Pro)</option>
                        </Form.Select>
                        <ErrorMessage
                          name="client_type"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3" controlId="listFournisseur">
                        <Form.Label>
                          {values.client_type === 'fournisseur' && '🏢 Fournisseur *'}
                          {values.client_type === 'particulier' && '👤 Client Particulier *'}
                          {values.client_type === 'entreprise' && '💼 Client Entreprise *'}
                        </Form.Label>
                        <Form.Select
                          className="form-control"
                          value={values.fournisseur}
                          name="fournisseur"
                          onChange={(e) => {
                            handleChange(e);
                            handleChangeFournisseur(e, setFieldValue);
                          }}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.fournisseur && !!errors.fournisseur
                          }
                        >
                          <option value="" disabled hidden>
                            Sélectionnez un utilisateur
                          </option>
                          {listFournisseurs?.length > 0 ? (
                            listFournisseurs.map((fournisseur) => (
                              <option
                                key={fournisseur.id}
                                value={fournisseur.id}
                              >
                                {values.client_type === 'particulier'
                                  ? `${fournisseur?.user_profil?.Nom || ''} ${fournisseur?.user_profil?.Prenom || ''}`.trim() || fournisseur?.email
                                  : fournisseur?.user_profil?.RaisonSocial || fournisseur?.email}
                              </option>
                            ))
                          ) : (
                            <option disabled>
                              Aucun utilisateur disponible
                            </option>
                          )}
                        </Form.Select>
                        <ErrorMessage
                          name="fournisseur"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group
                        className="mb-3"
                        controlId="formEmail_client"
                      >
                        <Form.Label>
                          {values.client_type === 'fournisseur' && 'Adresse mail fournisseur *'}
                          {values.client_type === 'particulier' && 'Adresse mail particulier *'}
                          {values.client_type === 'entreprise' && 'Adresse mail entreprise *'}
                        </Form.Label>
                        <Form.Control
                          className="form-control"
                          type="email"
                          placeholder="nom@exemple.com"
                          name="selectedFournisseurEmail"
                          value={
                            values?.email_fournisseur ||
                            selectedFournisseurEmail
                          }
                          onChange={(e) => {
                            const value = e.target.value;
                            setSelectedFournisseurEmail(value);
                            setFieldValue("selectedFournisseurEmail", value);
                          }}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.selectedFournisseurEmail &&
                            !!errors.selectedFournisseurEmail
                          }
                        />
                        <ErrorMessage
                          name="selectedFournisseurEmail"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    {values.client_type === 'fournisseur' && (
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formNom_telfournisseur"
                        >
                          <Form.Label>N° de téléphone Fournisseur </Form.Label>
                          <Form.Control
                            className="form-control"
                            type="text"
                            name="telFournisseurVal"
                            placeholder="N° de téléphone"
                            value={values?.TelFournisseur || telFournisseurVal}
                            onChange={(e) => {
                              const value = e.target.value;
                              setTelFournisseurVal(value);
                              setFieldValue("TelFournisseur", value);
                            }}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.telFournisseurVal &&
                              !!errors.telFournisseurVal
                            }
                          />
                          <ErrorMessage
                            name="telFournisseurVal"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group
                        className="mb-3"
                        controlId="formNom_Nomclient"
                      >
                        <Form.Label>Nom Client </Form.Label>
                        <Form.Control
                          className="form-control"
                          type="text"
                          name="NomClient"
                          placeholder="Nom Client"
                          value={values.NomClient}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.NomClient && !!errors.NomClient}
                        />
                        <ErrorMessage
                          name="NomClient"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group
                        className="mb-3"
                        controlId="formPrenom_client"
                      >
                        <Form.Label>Prénom Client </Form.Label>
                        <Form.Control
                          className="form-control"
                          type="text"
                          name="PrenomClient"
                          placeholder="Prénom Client"
                          value={values.PrenomClient}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.PrenomClient && !!errors.PrenomClient
                          }
                        />
                        <ErrorMessage
                          name="PrenomClient"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group
                        className="mb-3"
                        controlId="formTelephone_client"
                      >
                        <Form.Label>N° de téléphone client </Form.Label>
                        <Form.Control
                          className="form-control"
                          type="text"
                          name="telephone_client"
                          placeholder="Télephone Client"
                          value={values.telephone_client}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.telephone_client &&
                            !!errors.telephone_client
                          }
                        />
                        <ErrorMessage
                          name="telephone_client"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    {values.client_type !== 'particulier' && (
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formRaisonSocial_client"
                        >
                          <Form.Label>Raison Social Client</Form.Label>
                          <Form.Control
                            className="form-control"
                            type="text"
                            name="RaisonSocialClient"
                            placeholder="Raison Social Client"
                            value={values.RaisonSocialClient}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.RaisonSocialClient &&
                              !!errors.RaisonSocialClient
                            }
                          />
                          <ErrorMessage
                            name="RaisonSocialClient"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                    )}
                    {/* Sans condition de segment : le back-office saisit pour le
                        compte du client, quel que soit son tag. */}
                    <Col>
                      <Form.Group className="mb-3" controlId="formReferenceClient">
                        <Form.Label>Référence client</Form.Label>
                        <Form.Control
                          className="form-control"
                          type="text"
                          name="reference_client"
                          maxLength={50}
                          placeholder="N° de bon de commande, de chantier…"
                          value={values.reference_client}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.reference_client && !!errors.reference_client
                          }
                        />
                        <Form.Text className="text-muted">
                          Figurera sur la facture du client.
                        </Form.Text>
                        <ErrorMessage
                          name="reference_client"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3" controlId="listLivreur">
                        <Form.Label>Livreur</Form.Label>
                        <Form.Select
                          className="form-control"
                          value={values.livreur}
                          name="livreur"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.livreur && !!errors.livreur}
                        >
                          <option value="" disabled hidden>
                            Sélectionnez un livreur
                          </option>
                          {listLivreur?.map((livreur) => (
                            <option key={livreur.id} value={livreur.id}>
                              {livreur.nom} {livreur.prenom}
                            </option>
                          ))}
                        </Form.Select>
                        <ErrorMessage
                          name="livreur"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    {/*
                    <Col>
                      <Form.Label>Heure de livraison souhaitée: </Form.Label>
                      <input
                        type="datetime-local" // Définition du type datetime-local
                        id="date_livraisson"
                        min={currentDate}
                        name="date_livraisson"
                        className="form-control"
                        value={values.date_livraisson}
                        placeholder=""
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.date_livraisson && !!errors.date_livraisson
                        }
                      />
                      <ErrorMessage
                        name="date_livraisson"
                        component="div"
                        className="text-danger"
                      />
                    </Col>
                    */}
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group className="mb-3" controlId="formBordereau">
                        <Form.Label>Bordereau</Form.Label>
                        <Form.Control
                          className="form-control"
                          type="file"
                          name="file"
                          placeholder="Bordereau"
                          accept=".pdf"
                          // value={values.file}
                          onChange={(event) => {
                            const elemtFile = event.currentTarget.files[0];
                            setFile(elemtFile);
                            setFieldValue("file", elemtFile);
                          }}
                          onBlur={handleBlur}
                          isInvalid={touched.file && !!errors.file}
                        />
                        <ErrorMessage
                          name="file"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3" controlId="formLastName">
                        <Form.Label>Statut de Commande</Form.Label>
                        <Form.Select
                          className="form-control"
                          type="text"
                          name="statut_commande"
                          placeholder="statut commande"
                          value={values.statut_commande}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.statut_commande && !!errors.statut_commande
                          }
                        >
                          <option>Sélectionnez le Statut de Commande</option>
                          <option value="1">En cours de livraison</option>
                          <option value="2">Livré</option>
                          <option value="3">En cours de préparation</option>
                          <option value="6">Annulé</option>
                        </Form.Select>
                        <ErrorMessage
                          name="statut_commande"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group
                        className="mb-3"
                        controlId="formStatutPaiement"
                      >
                        <Form.Label>Statut de paiement</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          className="form-control"
                          name="statut_paiement"
                          placeholder="Statut paiement"
                          value={values.statut_paiement}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.statut_paiement && !!errors.statut_paiement
                          }
                        >
                          <option>Sélectionnez le Statut de paiement</option>
                          <option value="1">Facturé</option>
                          <option value="2">Non Facturé</option>
                        </Form.Select>
                        <ErrorMessage
                          name="statut_paiement"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  {isGMapsLoaded && (
                    <Row>
                      <Col>
                        <Form.Group
                          className="mb-3"
                          controlId="formAddressPickup"
                        >
                          <Form.Label>Adresse Pick Up</Form.Label>
                          <PlacesAutocompleteComponent
                            name="pickupAdr"
                            hasCoordinates={!!(values.altitude_Fournisseur && values.longitude_Fournisseur)}
                            value={values.pickupAdr}
                            setFieldValue={setFieldValue}
                            searchOptions={searchOptions}
                            setFieldTouched={setFieldTouched}                
                            handleFieldBlur={() => handleBlur("pickupAdr")} 
                            setFieldError={setFieldError} 
                            isInvalid={
                              touched.pickupAdr && !!errors.pickupAdr
                            }
                          />
                          <ErrorMessage
                            name="pickupAdr"
                            component="div"
                            className="text-danger"
                          />
                          {/* Les adresses du client, avec leurs coordonnees deja
                              en base : en cliquer une garantit la latitude et la
                              longitude sans geocodage. C'est le chemin le plus
                              fiable des trois, d'ou sa place juste sous le champ. */}
                          {adressesClient && (
                            <div className="mt-2 d-flex flex-wrap gap-2">
                              {adressesClient.magasin && (
                                <Button
                                  type="button"
                                  size="sm"
                                  variant="outline-primary"
                                  onClick={() =>
                                    choisirAdresseRamassage(
                                      adressesClient.magasin,
                                      setFieldValue,
                                      setFieldError
                                    )
                                  }
                                >
                                  🏪 {adressesClient.magasin.adresse}
                                </Button>
                              )}
                              {(adressesClient.recentes ?? []).map((a, i) => (
                                <Button
                                  key={`${a.adresse}-${i}`}
                                  type="button"
                                  size="sm"
                                  variant="outline-secondary"
                                  onClick={() =>
                                    choisirAdresseRamassage(a, setFieldValue, setFieldError)
                                  }
                                >
                                  {a.adresse}
                                </Button>
                              ))}
                              {!adressesClient.magasin &&
                                (adressesClient.recentes ?? []).length === 0 && (
                                  <span className="text-muted small">
                                    Aucune adresse d'enlèvement connue pour ce client.
                                  </span>
                                )}
                            </div>
                          )}
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group className="mb-3" controlId="formAddress">
                          <Form.Label>Adresse Livraison</Form.Label>
                          <PlacesAutocompleteComponent
                            name="address"
                            hasCoordinates={!!(values.altitude_Livreur && values.longitude_Livreur)}
                            value={values.address}
                            setFieldValue={setFieldValue}
                            searchOptions={searchOptions}
                            setFieldTouched={setFieldTouched}   
                            handleFieldBlur={() => handleBlur("address")} 
                            setFieldError={setFieldError} 
                            isInvalid={
                              touched.address && !!errors.address
                            }                
                          />
                          <ErrorMessage
                            name="address"
                            component="div"
                            className="text-danger"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  )}

                  <Row>
                    <Col>
                      <Form.Group
                        className="mb-3"
                        controlId="formBondelivraison"
                      >
                        <Form.Label>Numéro Bon de livraison</Form.Label>
                        <Form.Control
                          className="form-control"
                          type="text"
                          name="numBonLivraison"
                          placeholder="Numéro Bon de livraison"
                          value={values.numBonLivraison}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.numBonLivraison && !!errors.numBonLivraison
                          }
                        />
                        <ErrorMessage
                          name="numBonLivraison"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3" controlId="formCommentaire">
                        <Form.Label>Commentaire</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          className="form-control"
                          name="Commentaire"
                          placeholder="Commentaire"
                          value={values.Commentaire}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          maxLength={500}
                          isInvalid={
                            touched.Commentaire && !!errors.Commentaire
                          }
                        />
                        <Form.Text className="text-muted">
                          {values.Commentaire?.length || 0}/500 caractères
                        </Form.Text>
                        <ErrorMessage
                          name="Commentaire"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3" controlId="formMontantCommande">
                        <Form.Label>Montant marchandise</Form.Label>
                        <Form.Control
                          className="form-control"
                          type="number"
                          step="0.01"
                          name="MontantCommande"
                          placeholder="Montant marchandise"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.MontantCommande && !!errors.MontantCommande
                          }
                        />
                        <ErrorMessage
                          name="MontantCommande"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              {/* Montants */}
              <Card className="mb-3">
                <Card.Body>
                  <Card.Title className="pb-3">Montants :</Card.Title>
                  <Row>
                    <Col>
                      <Form.Group className="mb-3" controlId="formTarifBase">
                        <Form.Label>Tarif base (€)</Form.Label>
                        <Field
                          type="number"
                          name="tarif_base"
                          placeholder="Tarif base"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="tarif_base"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>

                    <Col>
                      <Form.Group className="mb-3" controlId="formPoidsSupplement">
                        <Form.Label>Poids Supplément (€)</Form.Label>
                        <Field
                          type="number"
                          name="poids_supplement"
                          placeholder="Poids Supplément"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="poids_supplement"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>

                    <Col>
                      <Form.Group className="mb-3" controlId="formTempsSupp">
                        <Form.Label>Temps Supplément (min)</Form.Label>
                        <Field
                          type="number"
                          name="temps_supplement"
                          placeholder="Temps supplément"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="temps_supplement"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>

                    <Col>
                      <Form.Group className="mb-3" controlId="formSuppLivraison">
                        <Form.Label>Supp. Livraison (€)</Form.Label>
                        <Field
                          type="number"
                          name="livraison_supplement"
                          placeholder="Supp. Livraison"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="livraison_supplement"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group className="mb-3" controlId="formTarifLivraison">
                        <Form.Label>Tarif de Livraison</Form.Label>
                        <Field
                          type="number"
                          name="livraisonHT"
                          placeholder="Tarif de Livraison"
                          className="form-control"
                          value={values.livraisonHT}
                          readOnly
                        />
                        <ErrorMessage
                          name="livraisonHT"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    {/* 
                    <Col>
                      <Form.Group className="mb-3" controlId="formCommission">
                        <Form.Label>Commission %</Form.Label>
                        <Field
                          type="number"
                          name="commission"
                          placeholder="Commission %"
                          className="form-control"
                          value={values?.commission || comissionVal}
                          onChange={(e) => {
                            const value = e.target.value;
                            setComissionVal(value);
                            setFieldValue("commission", value);
                          }}
                        />
                        <ErrorMessage
                          name="commission"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    */}
                    <Col>
                      <Form.Group className="mb-3" controlId="formtva">
                        <Form.Label>TVA</Form.Label>
                        <Field
                          type="number"
                          name="TVA"
                          placeholder="TVA"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="TVA"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group className="mb-3" controlId="formMontantTTC">
                        <Form.Label>Montant TTC</Form.Label>
                        <Field
                          type="number"
                          name="TTC"
                          placeholder="Montant TTC"
                          className="form-control"
                          value={values?.TTC}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFieldValue("TTC", value);
                          }}
                        />
                        <ErrorMessage
                          name="TTC"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              {/* transport */}
              <Card className="mb-3">
                <Card.Body>
                  <Card.Title className="pb-3">Détails transport :</Card.Title>
                  <Row>
                    <Col>
                      <Form.Group className="mb-3" controlId="formPoids">
                        <Form.Label>Poids</Form.Label>
                        <Field
                          as="select"
                          name="poids"
                          className="form-control"
                        >
                          <option value="">Poids livraison (en kilos)</option>
                          <option value="-150">- de 150 kilos</option>
                          <option value="151-300">151 à 300 Kg</option>
                          <option value="301-450">301 à 450 Kg</option>
                          <option value="451-600">451 à 600 Kg</option>
                          <option value="601-750">601 à 750 Kg</option>
                          <option value="751-900">751 à 900 Kg</option>
                          <option value="901-1350">901 à 1350 Kg</option>
                        </Field>
                        <ErrorMessage
                          name="poids"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3" controlId="formDateLivraison">
                        <Form.Label>Heure de livraison souhaitée</Form.Label>
                        <Field
                          type="datetime-local"
                          name="date_livraisson"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="date_livraisson"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group className="mb-3" controlId="formTempsEstime">
                        <Form.Label>Temps estimé (min)</Form.Label>
                        <Field
                          type="number"
                          name="temps_estime"
                          placeholder="Ex: 1"
                          className="form-control"
                        />
                        <ErrorMessage
                          name="temps_estime"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>

                    <Col>
                      <Form.Group className="mb-3" controlId="formTypeLivraison">
                        <Form.Label>Type de Livraison</Form.Label>
                        <Field
                          as="select"
                          name="type_livraison"
                          className="form-control"
                        >
                          <option value="" disabled>Choisir un type</option>
                          <option value="Flex">Flex</option>
                          <option value="Urgent">Urgent</option>
                          <option value="Planifiée">Planifiée</option>
                        </Field>
                        <ErrorMessage
                          name="type_livraison"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              {/* Manutention a la creation. Jusqu'ici absente de cet ecran : il
                  fallait enregistrer la commande, la rouvrir en edition, puis la
                  chiffrer — deux ecrans pour un acte.

                  Deux modes exclusifs, comme a l'edition. Le serveur chiffre le
                  bareme avec la grille du CLIENT et refuse les deux modes a la
                  fois ; on ne recalcule rien ici. */}
              <Card className="mb-3">
                <Card.Body>
                  <Card.Title className="pb-3">
                    Manutention <span className="text-muted fs-6">(optionnel)</span>
                  </Card.Title>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Distance de portage</Form.Label>
                        <Form.Select
                          className="form-control"
                          value={manutentionReponses.distance}
                          disabled={montantManutentionSaisi}
                          onChange={(e) =>
                            setManutentionReponses((p) => ({ ...p, distance: e.target.value }))
                          }
                        >
                          <option value="">—</option>
                          <option value="0-5">0 a 5 m</option>
                          <option value="5-15">5 a 15 m</option>
                          <option value="15-30">15 a 30 m</option>
                          <option value="30-50">30 a 50 m</option>
                          <option value="50+">plus de 50 m</option>
                        </Form.Select>
                        <Form.Text className="text-muted">
                          C'est elle qui declenche le bareme.
                        </Form.Text>
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Obstacles</Form.Label>
                        <Form.Select
                          className="form-control"
                          value={manutentionReponses.obstacles}
                          disabled={montantManutentionSaisi}
                          onChange={(e) =>
                            setManutentionReponses((p) => ({ ...p, obstacles: e.target.value }))
                          }
                        >
                          <option value="">—</option>
                          <option value="aucun">Aucun</option>
                          <option value="quelques">Quelques</option>
                          <option value="difficile">Difficile</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Etage</Form.Label>
                        <Form.Select
                          className="form-control"
                          value={manutentionReponses.etage}
                          disabled={montantManutentionSaisi}
                          onChange={(e) =>
                            setManutentionReponses((p) => ({ ...p, etage: e.target.value }))
                          }
                        >
                          <option value="">—</option>
                          <option value="non_concerne">Non concerne</option>
                          <option value="rdc_surleve">RDC sureleve</option>
                          <option value="1er">1er etage</option>
                          <option value="2e_plus">2e etage ou plus</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Ascenseur</Form.Label>
                        <Form.Select
                          className="form-control"
                          value={manutentionReponses.ascenseur}
                          disabled={montantManutentionSaisi}
                          onChange={(e) =>
                            setManutentionReponses((p) => ({ ...p, ascenseur: e.target.value }))
                          }
                        >
                          <option value="">—</option>
                          <option value="oui">Oui</option>
                          <option value="non">Non</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Colis le plus lourd</Form.Label>
                        <Form.Select
                          className="form-control"
                          value={manutentionReponses.poids_colis}
                          disabled={montantManutentionSaisi}
                          onChange={(e) =>
                            setManutentionReponses((p) => ({ ...p, poids_colis: e.target.value }))
                          }
                        >
                          <option value="">—</option>
                          <option value="normal">Normal</option>
                          <option value="lourd">Lourd (deux porteurs)</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>ou montant negocie (EUR HT)</Form.Label>
                        <Form.Control
                          type="number"
                          step="0.01"
                          min="0"
                          placeholder="ex. 45"
                          value={manutentionMontant}
                          disabled={manutentionReponses.distance !== ""}
                          onChange={(e) => setManutentionMontant(e.target.value)}
                        />
                        <Form.Text className="text-muted">
                          Exclusif du bareme : l'un desactive l'autre.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <p className="text-muted small mb-0">
                    Le montant est calcule par le serveur, avec la grille de ce
                    client. Il apparaitra sur la fiche de la commande.
                  </p>
                </Card.Body>
              </Card>

              <Row>
                <Col>
                  <Form.Group
                    className="mt-3 d-flex justify-content-end align-items-center"
                    controlId="formSubmit"
                  >
                    <Button
                      variant="primary"
                      type="submit"
                      disabled={isSubmitting}
                      onClick={() => {
                        if (!isValid || Object.keys(errors).length > 0) {
                          const messages = Object.values(errors).flat();
                          if (messages.length > 0) {
                            toast.error(
                              <div>
                                <strong>Formulaire incomplet :</strong>
                                <ul className="mb-0 ps-3 mt-1">
                                  {messages.map((m, i) => <li key={i}>{m}</li>)}
                                </ul>
                              </div>,
                              { autoClose: 8000 }
                            );
                          }
                        }
                      }}
                    >
                      Enregistrer la livraison
                    </Button>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
      <ModalValidation
        show={showOkModal}
        onClose={handleOkModalClose}
        onConfirm={handleOkModalClose}
        text={"Votre commande a été enregistrée et envoyer avec succès"}
      />

      <ConfirmationPaiementCarte
        show={showPaiementCarteModal}
        onClose={() => {
          setShowPaiementCarteModal(false);
          setValeursEnAttente(null);
        }}
        onConfirm={async () => {
          setShowPaiementCarteModal(false);
          if (valeursEnAttente) {
            const valeurs = valeursEnAttente;
            setValeursEnAttente(null);
            await HandleSave(valeurs);
          }
        }}
      />
    </Container>
  );
}


function AutoUpdateLivraisonHT({ pricingSupplements }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    // `pricingSupplements` est nul tant qu'aucun client n'est choisi : la grille
    // depend de LUI. L'operateur `in` leverait sur null, et surtout preremplir un
    // supplement avant de savoir quel client paie serait preremplir un faux prix.
    if (!pricingSupplements) return;

    if (values.type_livraison && values.type_livraison in pricingSupplements) {
      setFieldValue("livraison_supplement", pricingSupplements[values.type_livraison]);
    }
  }, [values.type_livraison, pricingSupplements, setFieldValue]);

  useEffect(() => {
    const base = parseFloat(values.tarif_base || 0);
    const poids = parseFloat(values.poids_supplement || 0);
    const temps = parseFloat(values.temps_supplement || 0);
    const livraisonSupp = parseFloat(values.livraison_supplement || 0);

    const totalHT = base + poids + temps + livraisonSupp;
    const htValue = parseFloat(totalHT.toFixed(2));

    setFieldValue("livraisonHT", htValue);
    setFieldValue("tarif_ht", htValue);

    // TTC + tarif_ttc calculés ici (même formule qu'EditCommandeFournisseur/AutoCalculateFields)
    // pour que tarif_ttc ne reste plus jamais vide à la création.
    const tva = parseFloat(values.TVA) || 0;
    const ttcValue = parseFloat((htValue * (1 + tva / 100)).toFixed(2));
    setFieldValue("TTC", ttcValue);
    setFieldValue("tarif_ttc", ttcValue);
  }, [
    values.tarif_base,
    values.poids_supplement,
    values.temps_supplement,
    values.livraison_supplement,
    values.TVA,
    setFieldValue,
  ]);

  return null;
}

export default AddCommandeFournisseur;
